export default "__VITE_ASSET__c_Ptuh1j__"